import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Button, Checkbox, Flex, Form, Layout } from "antd";
import { SocialIcon } from "react-social-icons";
import Highcharts from "highcharts";

import { GET, POST } from "../../../providers/useAxiosQuery";
import FloatInput from "../../../providers/FloatInput";
import FloatInputMask from "../../../providers/FloatInputMask";
import ScorecardGraph from "../../../providers/ScorecardGraph";
import getChartScreenshotBase64 from "../../../providers/getChartScreenshotBase64";

require("highcharts/highcharts-more")(Highcharts);
require("highcharts/modules/accessibility")(Highcharts);
require("highcharts/modules/variable-pie")(Highcharts);
require("highcharts/modules/no-data-to-display")(Highcharts);
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/offline-exporting")(Highcharts);
require("highcharts/modules/export-data")(Highcharts);
require("highcharts/modules/boost")(Highcharts);

export default function PageScoreCardFormSend() {
	const navigate = useNavigate();
	const [errMessage, setErrMessage] = useState({
		type: "",
		message: "",
	});
	const [firstname, setFirstname] = useState("");

	const [graphResult, setGraphResult] = useState([]);

	GET(
		`api/scorecard_result?batch_id=${localStorage.getItem(
			"scorecard_batch_id"
		)}`,
		"scorecard_result",
		async (res) => {
			if (res && res.data) {
				let data = res.data;
				let findForm = data[0];
				console.log("findForm: ", findForm);

				if (findForm) {
					let form_question_answer_batches =
						findForm.form_question_answer_batches;
					let form_question_answer_batch = form_question_answer_batches.length
						? form_question_answer_batches[0]
						: null;
					let form_question_answers =
						form_question_answer_batch?.form_question_answers || [];

					let pluckedCategories = form_question_answers.reduce(
						(acc, answer) => {
							let form_question_category_id = answer.form_question_category_id;
							if (!acc.includes(form_question_category_id)) {
								acc.push(form_question_category_id);
							}
							return acc;
						},
						[]
					);

					let form_question_categories = findForm.form_question_categories
						?.filter((category) => pluckedCategories.includes(category.id))
						.filter((category) => category.graph_visible === 1);

					let categories = [];

					if (form_question_answer_batch) {
						form_question_categories.forEach((category) => {
							let filter_form_question_answers = form_question_answers.filter(
								(answer) => answer.form_question_category_id === category.id
							);

							let countAnswered = filter_form_question_answers.reduce(
								(acc, answer) =>
									acc + (answer.answer ? Number(answer.answer) * 5 : 0),
								0
							);
							countAnswered =
								countAnswered > 0 && filter_form_question_answers.length
									? countAnswered / filter_form_question_answers.length
									: countAnswered;

							categories.push({
								name: category.category,
								y: countAnswered,
								color: category.graph_color,
							});
						});
					}

					setGraphResult(categories);
				}
			}
		},
		false
	);

	const { mutate: mutateUser, isLoading: isLoadingUser } = POST(
		`api/scorecard_email_pub`,
		"scorecard_email_pub"
	);

	const onFinish = async (values) => {
		let chart = Highcharts.charts.find(
			(c) => c?.renderTo.id === "div_scorecard_graph"
		);
		let chart_screenshot = await getChartScreenshotBase64(chart);

		// let email = values.email;
		// let emailSplit = email.split("@");
		// if (emailSplit.length > 1) {
		// 	// add random number to email to avoid duplicate email error
		// 	emailSplit[0] = emailSplit[0] + "+" + Math.floor(Math.random() * 1000);
		// 	email = emailSplit.join("@");
		// }

		let data = {
			firstname: values.firstname ?? "",
			lastname: values.lastname ?? "",
			email: values.email ?? "",
			contact_no: values.contact_no ?? "",
			is_receive: values.is_receive ? 1 : 0,
			batch_id: localStorage.getItem("scorecard_batch_id") || "",
			link: window.location.origin,
			chart_screenshot: chart_screenshot,
		};

		mutateUser(data, {
			onSuccess: (res) => {
				if (res.success) {
					setErrMessage({
						type: "success",
						message: res.message,
					});
					localStorage.removeItem("scorecardAnswers");
					setTimeout(() => {
						navigate("/scorecard/form/success");
					}, 1000);
				} else {
					setErrMessage({
						type: "error",
						message: res.message,
					});
				}
			},
			onError: (err) => {
				let errors = err.response.data.errors;
				if (errors) {
					let fieldnames = Object.keys(errors);
					Object.values(errors).map((messages, index) => {
						let fieldname = fieldnames[index].split("_");
						fieldname.map((string, key) => {
							fieldname[key] = capitalize(string);

							return false;
						});
						fieldname = fieldname.join(" ");

						setErrMessage({
							type: "error",
							message: messages.join("\n\r"),
						});

						return false;
					});
				} else {
					setErrMessage({
						type: "error",
						message: err.code + ": " + err.message,
					});
				}
			},
		});
	};

	const capitalize = (s) => {
		if (typeof s !== "string") return "";
		return s.charAt(0).toUpperCase() + s.slice(1);
	};

	return (
		<Layout.Content>
			<div className="main-content">
				<div className="logo-wrapper">
					<img
						src="/assets/joyalifevertical_green_on_white_transparent.png"
						alt="joyalifevertical_green_on_white_transparent.png"
					/>
				</div>

				<div className="content-title">
					Almost there! Just tell us where to send your scorecard.
				</div>

				<div
					style={{
						visibility: "hidden",
						height: 0,
						// overflow: "hidden",
						width: 1000,
					}}
				>
					<ScorecardGraph
						Highcharts={Highcharts}
						graphResult={graphResult}
						from="scorecard_send"
						firstname={firstname}
					/>
				</div>

				<Form onFinish={onFinish}>
					<Form.Item
						name="firstname"
						rules={[{ required: true, message: "This field is required" }]}
					>
						<FloatInput
							label="First Name"
							required
							onBlur={(e) => setFirstname(e.target.value)}
						/>
					</Form.Item>
					<Form.Item
						name="lastname"
						rules={[{ required: true, message: "This field is required" }]}
					>
						<FloatInput label="Last Name" required />
					</Form.Item>
					<Form.Item
						name="email"
						rules={[
							{ required: true, message: "This field is required" },
							{
								type: "email",
								message: "Please enter a valid email address",
							},
						]}
					>
						<FloatInput label="Email Address" required />
					</Form.Item>
					<Form.Item name="contact_no">
						<FloatInputMask
							label="Mobile Number"
							placeholder="Mobile Number"
							maskLabel="contact_no"
							maskType="9999 999 999"
						/>
					</Form.Item>

					<Form.Item name="is_receive" valuePropName="checked">
						<Checkbox>
							<i>I'd love to receive simple tips and tools from Joya.</i>
						</Checkbox>
					</Form.Item>

					<div className="text-center">
						<Button type="primary" loading={isLoadingUser} htmlType="submit">
							EMAIL MY SCORECARD
						</Button>
					</div>

					{errMessage.message && (
						<Alert type={errMessage.type} message={errMessage.message} />
					)}
				</Form>

				<div className="footer">
					<div className="follow-us">
						Stay connected for more inspiration. Follow us on our social media!
					</div>
					<Flex className="follow-us-icons">
						<SocialIcon url="http://facebook.com/myjoyalife" />
						<SocialIcon url="https://www.instagram.com/myjoyalife" />
						<SocialIcon url="https://www.tiktok.com/@myjoyalife?_t=ZS-8z1vqgh1jIF&_r=1" />
						<SocialIcon url="https://www.linkedin.com/company/myjoyalife" />
						<SocialIcon url="https://www.youtube.com/@myjoyalife" />
						<SocialIcon url="https://x.com/myjoyalife" />
						<SocialIcon url="https://threads.com/@myjoyalife?igshid=NTc4MTIwNjQ2YQ==" />
					</Flex>
				</div>
			</div>
		</Layout.Content>
	);
}
